import { render } from "./XIconSolidCrosshair.vue?vue&type=template&id=d7594dcc"
import script from "./XIconSolidCrosshair.vue?vue&type=script&lang=js"
export * from "./XIconSolidCrosshair.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidCrosshair.vue"]])

export default __exports__